import { render, staticRenderFns } from "./iri-modal.vue?vue&type=template&id=c8b2c68a&scoped=true&"
import script from "./iri-modal.vue?vue&type=script&lang=ts&"
export * from "./iri-modal.vue?vue&type=script&lang=ts&"
import style0 from "./iri-modal.vue?vue&type=style&index=0&id=c8b2c68a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b2c68a",
  null
  
)

export default component.exports